module.exports = __webpack_public_path__ + "static/media/apercu-light_italic.66ae4f08.woff2";